import { API_BASE } from './api.ts';

/** Esittelyversio (build-asetus VITE_DEMO=true). */
export const DEMO = import.meta.env.VITE_DEMO === 'true';
/** Palautekyselyn osoite, jos annettu. */
export const SURVEY_URL = import.meta.env.VITE_SURVEY_URL || null;

const VISIT_KEY = 'vm-demo-visit';

/** Kirjautuminen esimerkkikäyttäjänä: muistetaan vain tämän välilehden ajan. */
export function markDemoVisit(): void {
  try {
    sessionStorage.setItem(VISIT_KEY, '1');
  } catch {
    // ei tallennustilaa: seuraava lataus alkaa aloitussivulta
  }
}

/**
 * Uusi käynti (uusi välilehti tai selain suljettu välissä) alkaa aina aloitussivulta:
 * mahdollinen vanha istunto kirjataan ulos. Sivun päivitys samassa välilehdessä jatkaa.
 */
export async function startDemoVisit(): Promise<void> {
  if (!DEMO) return;
  let visiting = false;
  try {
    visiting = sessionStorage.getItem(VISIT_KEY) === '1';
  } catch {
    visiting = false;
  }
  if (visiting) return;
  await fetch(`${API_BASE}/auth/logout`, { method: 'POST', credentials: 'include' }).catch(
    () => undefined,
  );
}
